module.exports = __webpack_public_path__ + "img/E095.103def54.svg";